import React, {useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import BoardsTable from '../../tables/tunerTables/BoardsTable'

const useStyles = makeStyles((theme) => ({
  root: {
    display:"flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width:'100%',
    marginBottom:'1em'
  }
}));


export default function BoardsTabPanel(props) {
  console.log("render BoardsTabPanel");

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <BoardsTable/>
    </div>
  );
}